const addBoldTag = (src, lang_array) => {
  const occ = (src.split(">").length - 1);
  if (occ === 1) {
    return src;
  }
  // Find content
  const tmp = src.slice(1);
  let start = 0;
  let end;
  for (let i = 0; i < occ / 2; i++) {
    start += src.slice(start + 1).indexOf('>') + 1;
  }
  end = start + src.slice(start).indexOf('<');
  const content = tmp.slice(start, end - 1);

  let bold_word = content;
  lang_array.forEach(word => {
    bold_word = bold_word.split(word).join('<b>' + word + '</b>');
  })

  return src.slice(0, start - 1 + 2) + bold_word + tmp.slice(end - 1);
}

const words_to_bold = {
  fr_array : ['Pack pré-comptabilité', 'Fonctionnalités avancées', 'et 2 cartes Mastercard Business', 'et 3 encaissements de chèque',
            'accès comptable', 'prioritaire', 'Pack comptabilité', 'Pack&nbsp;comptabilité',
            '(10 cartes Mastercard Business)', '(5 cartes Mastercard Business)', '(2 cartes Mastercard Business)',
            '10 comptes', '25 comptes', '3&nbsp;encaissements', '10 cartes', 'conseiller dédié pour l\'ouverture',
            'Gestion avancée', 'et suivi personnalisé', 'Gestion des rôles et accès', 'IBAN respectifs',
            'Pack dépenses en équipe', 'Comptes illimités', 'VIP', 'conseiller dédié', 'IBAN respectif',
            'Outil de facturation', '1000', '500', '60', '30', '100', '3', '15&nbsp;', '5&nbsp;', '2&nbsp;',
            '15 ', '5 ', '2 '],
  es_array : ['Herramientas para la contabilidad', '25 subcuentas', 'Funcionalidades avanzadas', 'Automatización de la contabilidad',
            'prioritario', 'IBAN respectivos', 'Gestión de roles y accesos', 'Gestión avanzada',
            'Gestión de gastos en equipo', 'Subcuentas ilimitadas', 'acceso para el contable',
            'asesoramiento personalizado', 'VIP', 'Herramienta de facturación',
            '1000 ', '100 ', '3 ', '500 ', '15 ', '12 ', '60 ', '30 ', '10 ', '2 ', '5 '],
  it_array : ['Fatturazione elettronica', '25 conti', 'accesso dedicato per il commercialista', 'Funzionalità avanzate',
            'Contabilità semplificata', 'prioritario', 'Gestione avanzata dei ruoli e degli accessi',
            'Gestione delle spese', 'Gestione avanzata', 'IBAN separati', 'Conti illimitati',
            'illimitati', 'VIP',
            '100 ', '3 ', '15 ', '60 ', '30 ', '10 ', '500 ', '1000 ', '5 ', '2 '],
  de_array : ['25 Konten', 'in 72h', 'Buchhalter-Lesezugriff', 'Kundenservice 7/7 Tage',
            'Prioritärer', 'Erweiterte Funktionen', 'Buchhaltungstools', 'eigener IBAN',
            'Tools für Ausgabenverwaltung im Team', 'Unbegrenzte Anzahl an Konten',
            'VIP-Kundenservice', 'persönliche/r Berater/in', 'Unbegrenzte', 'Erweiterte Verwaltung',
            'sammelüberweisungen', 'Tool für die Rechnungsstellung', 'Lesezugriff für die Buchhaltung',
            'Buchhaltungspaket',
            '1 ', '1000 ', '1.000', '100 ', '100&nbsp;', '3 ', '15 ', '60 ', '60&nbsp;', '30 ', '10 ', '10&nbsp;',
            '500 ', '72 ', '2 ', '5 ', '5&nbsp;'],
  en_array : ['respective IBAN', 'Bookkeeping Pack', 'Advanced role management and access',
            'Role management and access', 'Team expenses pack', 'Priority', 'key account manager',
            'personalized service', 'Unlimited accounts', 'VIP', 'Advanced features', 'Accounting Pack',
            'Unlimited', 'accountant access', 'priority support', '2 Business', '10 accounts', 'Invoicing tool',
            '72 ', '2 ', '1,000 ', '1000', '100 ', '3 ', '15 ', '25', '5 ', '60 ', '30 ', '10 ', '10&nbsp;', '500 ']
}
const langs = ['fr', 'es', 'de', 'it', 'en'];

const formatText = () => {
  langs.forEach((lang) => {
    if (window.location.href.indexOf(`${lang}/pricing`) > -1) {
      var $elements = jQuery('.features');
      $elements.each(function () {
        let ret = '';
        $(this).html().split('\n').forEach((el) => {
          el.replace(addBoldTag(el, words_to_bold[`${lang}` + "_array"]));
          ret += addBoldTag(el, words_to_bold[`${lang}` + "_array"])
        });
        $(this).html(ret);
      });
    }
  })
}

export default formatText;
